var H = require("hogan.js");
window.gettext || require("ehogan-loader/gt.js");
window.jscAdd || require("ehogan-loader/jscmanager.js");
module.exports = function() { var T = new H.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b(t.v(interpolate( gettext("Минимальная длина - %(length)s символа. Разрешены латинские буквы, цифры и знак нижнего подчёркивания."), {'length': t.d("NameMinLength",c,p,1)||""}, true)));t.b("\n");return t.fl(); },partials: {}, subs: {  }}, "{{ ___0___ }}\n", H);return T[arguments[0] instanceof Array ? "ri" : "render"].apply(T, arguments); };


//////////////////
// WEBPACK FOOTER
// ./static-source/messages/access_char.html
// module id = 178
// module chunks = 4